export default [
    {
        file: '/components/Content/List.tsx',
        paths: ['components/content/list'],
        component: async () => (await import('./components/Content/List')).Content,
        meta: {
    "title": "List",
    "icon": "format_list_bulleted",
    "description": "Lists are continuous, vertical indexes of text or images."
}
    },
    {
        file: '/components/Form/Button.tsx',
        paths: ['components/form/button'],
        component: async () => (await import('./components/Form/Button')).Content,
        meta: {
    "title": "Button",
    "icon": "filter_center_focus",
    "description": "Buttons allow users to take actions, and make choices, with a single tap."
}
    },
    {
        file: '/components/Form/Checkbox.tsx',
        paths: ['components/form/checkbox'],
        component: async () => (await import('./components/Form/Checkbox')).Content,
        meta: {
    "title": "Checkbox",
    "icon": "check_box",
    "description": "Checkboxes allow the user to select one or more items from a set. Checkboxes can be used to turn an option on or off."
}
    },
    {
        file: '/components/Form/FAB.tsx',
        paths: ['components/form/fab'],
        component: async () => (await import('./components/Form/FAB')).Content,
        meta: {
    "title": "FAB",
    "icon": "add_circle",
    "description": "A floating action button (FAB) represents the primary action of a screen."
}
    },
    {
        file: '/components/Form/FormField.tsx',
        paths: ['components/form/form-field'],
        component: async () => (await import('./components/Form/FormField')).Content,
        meta: {
    "title": "FormField",
    "icon": "edit",
    "description": "A form field is a text caption for MWC input elements including <mwc-checkbox>, <mwc-radio>, and <mwc-switch>."
}
    },
    {
        file: '/components/Form/IconButton.tsx',
        paths: ['components/form/icon-button'],
        component: async () => (await import('./components/Form/IconButton')).Content,
        meta: {
    "title": "Icon Button",
    "icon": "filter_center_focus",
    "description": "Icon buttons allow users to take actions, and make choices, with a single tap."
}
    },
    {
        file: '/components/Form/IconButtonToggle.tsx',
        paths: ['components/form/icon-button-toggle'],
        component: async () => (await import('./components/Form/IconButtonToggle')).Content,
        meta: {
    "title": "Icon Button Toggle",
    "icon": "star_half",
    "description": "Toggle buttons can be used to group related options. To emphasize groups of related toggle buttons, a group should share a common container."
}
    },
    {
        file: '/components/Form/Radio.tsx',
        paths: ['components/form/radio'],
        component: async () => (await import('./components/Form/Radio')).Content,
        meta: {
    "title": "Radio",
    "icon": "radio_button_checked",
    "description": "Radio buttons allow the user to select one option from a set. Use radio buttons when the user needs to see all available options."
}
    },
    {
        file: '/components/Form/Select.tsx',
        paths: ['components/form/select'],
        component: async () => (await import('./components/Form/Select')).Content,
        meta: {
    "title": "Select",
    "icon": "fact_check",
    "description": "Selects display a list of choices on temporary surfaces."
}
    },
    {
        file: '/components/Form/Slider.tsx',
        paths: ['components/form/slider'],
        component: async () => (await import('./components/Form/Slider')).Content,
        meta: {
    "title": "Slider",
    "icon": "align_vertical_center",
    "description": "Sliders allow users to make selections from a range of values."
}
    },
    {
        file: '/components/Form/Switch.tsx',
        paths: ['components/form/switch'],
        component: async () => (await import('./components/Form/Switch')).Content,
        meta: {
    "title": "Switch",
    "icon": "toggle_on",
    "description": "Switches toggle the state of a single setting on or off. They are the preferred way to adjust settings on mobile."
}
    },
    {
        file: '/components/Form/TextField.tsx',
        paths: ['components/form/text-field'],
        component: async () => (await import('./components/Form/TextField')).Content,
        meta: {
    "title": "TextField",
    "icon": "text_format",
    "description": "Text fields let users enter and edit text."
}
    },
    {
        file: '/components/Form/Textarea.tsx',
        paths: ['components/form/textarea'],
        component: async () => (await import('./components/Form/Textarea')).Content,
        meta: {
    "title": "Textarea",
    "icon": "wrap_text",
    "description": "Text areas let users enter and edit text."
}
    },
    {
        file: '/components/Navigator/Drawer.tsx',
        paths: ['components/navigator/drawer'],
        component: async () => (await import('./components/Navigator/Drawer')).Content,
        meta: {
    "title": "Drawer",
    "icon": "menu",
    "description": "The Navigation Drawer is used to organize access to destinations and other functionality on an app."
}
    },
    {
        file: '/components/Navigator/Menu.tsx',
        paths: ['components/navigator/menu'],
        component: async () => (await import('./components/Navigator/Menu')).Content,
        meta: {
    "title": "Menu",
    "icon": "menu_open",
    "description": "Menus display a list of choices on temporary surfaces."
}
    },
    {
        file: '/components/Navigator/Tab.tsx',
        paths: ['components/navigator/tab'],
        component: async () => (await import('./components/Navigator/Tab')).Content,
        meta: {
    "title": "Tab",
    "icon": "tab_unselected",
    "description": "Tabs organize content across different screens, data sets, and other interactions."
}
    },
    {
        file: '/components/Navigator/TabBar.tsx',
        paths: ['components/navigator/tab-bar'],
        component: async () => (await import('./components/Navigator/TabBar')).Content,
        meta: {
    "title": "Tab Bar",
    "icon": "tab",
    "description": "Tabs organize content across different screens, data sets, and other interactions."
}
    },
    {
        file: '/components/Navigator/TopAppBar.tsx',
        paths: ['components/navigator/top-app-bar'],
        component: async () => (await import('./components/Navigator/TopAppBar')).Content,
        meta: {
    "title": "Top App Bar",
    "icon": "ad_units",
    "description": "Top App Bars are a container for items such as application title, navigation icon, and action items."
}
    },
    {
        file: '/components/Navigator/TopAppBarFixed.tsx',
        paths: ['components/navigator/top-app-bar-fixed'],
        component: async () => (await import('./components/Navigator/TopAppBarFixed')).Content,
        meta: {
    "title": "Top App Bar Fixed",
    "icon": "ad_units",
    "description": "Fixed Top App Bars are a container for items such as application title, navigation icon, and action items that are always visible."
}
    },
    {
        file: '/components/Prompt/Dialog.tsx',
        paths: ['components/prompt/dialog'],
        component: async () => (await import('./components/Prompt/Dialog')).Content,
        meta: {
    "title": "Dialog",
    "icon": "web_asset",
    "description": "Dialogs inform users about a task and can contain critical information, require decisions, or involve multiple tasks."
}
    },
    {
        file: '/components/Prompt/SnackBar.tsx',
        paths: ['components/prompt/snack-bar'],
        component: async () => (await import('./components/Prompt/SnackBar')).Content,
        meta: {
    "title": "SnackBar",
    "icon": "info",
    "description": "Snackbars provide brief messages about app processes at the bottom of the screen."
}
    },
    {
        file: '/components/Reminder/CircularProgress.tsx',
        paths: ['components/reminder/circular-progress'],
        component: async () => (await import('./components/Reminder/CircularProgress')).Content,
        meta: {
    "title": "Circular Progress",
    "icon": "timelapse",
    "description": "Progress indicators express an unspecified wait time or display the length of a process."
}
    },
    {
        file: '/components/Reminder/CircularProgressFourColor.tsx',
        paths: ['components/reminder/circular-progress-four-color'],
        component: async () => (await import('./components/Reminder/CircularProgressFourColor')).Content,
        meta: {
    "title": "Circular Progress four color",
    "icon": "timelapse",
    "description": "The four color circular progress indicator rotates between four colors in indeterminate mode."
}
    },
    {
        file: '/components/Reminder/Icon.tsx',
        paths: ['components/reminder/icon'],
        component: async () => (await import('./components/Reminder/Icon')).Content,
        meta: {
    "title": "Icon",
    "icon": "font_download",
    "description": "Icon displays an icon with a chosen name from the Material Icons font, or from any font that supports ligatures."
}
    },
    {
        file: '/components/Reminder/LinearProgress.tsx',
        paths: ['components/reminder/linear-progress'],
        component: async () => (await import('./components/Reminder/LinearProgress')).Content,
        meta: {
    "title": "Linear Progress",
    "icon": "hourglass_empty",
    "description": "Progress indicators express an unspecified wait time or display the length of a process."
}
    }
];